import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { ExclamationCirlce } from "../../../../../assets/svgIcons";
import primaryComponents from "../../../../primaryComponents";

export const ManualList = ({ formData, setFormData = () => {} }) => {
  return (
    <div
      className={` ${globalStyles["cardWithBackground"]} white`}
      style={{ gap: "15px" }}
    >
      <div className="d-flex justify-content-between">
        <h5>Paste Phone Numbers</h5>

        {/* <p>
          <span>Import from CSV</span> | <span>Clear all</span>
        </p> */}
      </div>

      <primaryComponents.TextArea
        placeholder={"Enter phone numbers"}
        value={formData?.recipient_phone_numbers}
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, recipient_phone_numbers: value }));
        }}
        style={{ minHeight: "200px" }}
      />

      <div
        className={`${globalStyles.cardWithBackground} flex-row`}
        style={{ gap: "15px" }}
      >
        <ExclamationCirlce width="25px" height="25px" />
        <div>
          <h6>Formatting Guidelines</h6>
          <p>
            Enter phone numbers seperate by commas. We automatically detec
            country codes and removes duplicates. Paste directly from excel or
            CSV file columns
          </p>
        </div>
      </div>
    </div>
  );
};
